import { render, staticRenderFns } from "./LeaplyLock.vue?vue&type=template&id=031637e7"
var script = {}
import style0 from "./LeaplyLock.vue?vue&type=style&index=0&id=031637e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports